module.exports = __webpack_public_path__ + "img/img_brand25.eb95df22.jpg";